import React from 'react';
import { Link } from 'react-router-dom';

const ProjectsOverview = () => {
  return (
    <div>
      {/* Header Section */}
      <section
        className="hero-section min-h-[400px] flex items-center"
        style={{ backgroundImage: 'url(https://images.pexels.com/photos/35253093/pexels-photo-35253093.jpeg?auto=compress&cs=tinysrgb&w=1920)' }}
      >
        <div className="hero-overlay w-full min-h-[400px] flex items-center">
          <div className="container mx-auto px-4 text-white">
            <h1 className="text-5xl font-bold mb-4">Turnkey Projects</h1>
            <p className="text-xl text-gray-200">Complete Solutions from Design to Commissioning</p>
          </div>
        </div>
      </section>

      {/* Introduction */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-6 section-title inline-block">End-to-End Project Solutions</h2>
            <p className="text-lg text-gray-700 mt-8">
              Athena offers comprehensive turnkey project solutions across various industries. From initial design and engineering to equipment manufacturing, installation, and commissioning, we handle every aspect of your project with expertise and precision.
            </p>
          </div>
        </div>
      </section>

      {/* Dairy Processing Projects */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold mb-12 text-center section-title inline-block">Dairy Processing Ventures</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto mt-12">
            <Link to="/projects/liquid-milk" className="card-hover bg-white rounded-lg p-6 border-2 border-transparent hover:border-accent">
              <h3 className="text-xl font-bold mb-3">Liquid Milk Processing Plant</h3>
              <p className="text-gray-600 text-sm mb-3">Capacity: 5,000 to 10,00,000 liters/day</p>
              <p className="text-gray-700 text-sm">Complete milk processing solutions for standardized, toned, and double toned milk production</p>
              <div className="mt-4 text-green font-semibold">View Details →</div>
            </Link>

            <Link to="/projects/ghee" className="card-hover bg-white rounded-lg p-6 border-2 border-transparent hover:border-accent">
              <h3 className="text-xl font-bold mb-3">Ghee Processing Plant</h3>
              <p className="text-gray-600 text-sm mb-3">Agmark Standard Compliant</p>
              <p className="text-gray-700 text-sm">Complete ghee extraction and processing facility from butter/cream to packaged ghee</p>
              <div className="mt-4 text-green font-semibold">View Details →</div>
            </Link>

            <Link to="/projects/dahi-lassi" className="card-hover bg-white rounded-lg p-6 border-2 border-transparent hover:border-accent">
              <h3 className="text-xl font-bold mb-3">Dahi/Lassi/Yoghurt Plant</h3>
              <p className="text-gray-600 text-sm mb-3">Fermented Dairy Products</p>
              <p className="text-gray-700 text-sm">Traditional and modern fermented dairy product manufacturing facilities</p>
              <div className="mt-4 text-green font-semibold">View Details →</div>
            </Link>

            <Link to="/projects/smp-wmp" className="card-hover bg-white rounded-lg p-6 border-2 border-transparent hover:border-accent">
              <h3 className="text-xl font-bold mb-3">SMP/WMP/Dairy Whitener Plant</h3>
              <p className="text-gray-600 text-sm mb-3">Powder Production Facility</p>
              <p className="text-gray-700 text-sm">Multi-effect evaporators and spray dryers for milk powder production</p>
              <div className="mt-4 text-green font-semibold">View Details →</div>
            </Link>

            <Link to="/projects/paneer" className="card-hover bg-white rounded-lg p-6 border-2 border-transparent hover:border-accent">
              <h3 className="text-xl font-bold mb-3">Paneer Processing Plant</h3>
              <p className="text-gray-600 text-sm mb-3">Fresh Cheese Production</p>
              <p className="text-gray-700 text-sm">Acid coagulation and pressing equipment for high-quality paneer production</p>
              <div className="mt-4 text-green font-semibold">View Details →</div>
            </Link>

            <Link to="/projects/khoa" className="card-hover bg-white rounded-lg p-6 border-2 border-transparent hover:border-accent">
              <h3 className="text-xl font-bold mb-3">Continuous Khoa Making Plant</h3>
              <p className="text-gray-600 text-sm mb-3">Traditional Sweet Base</p>
              <p className="text-gray-700 text-sm">Modern continuous khoa production systems for confectionery industry</p>
              <div className="mt-4 text-green font-semibold">View Details →</div>
            </Link>

            <Link to="/projects/ice-cream" className="card-hover bg-white rounded-lg p-6 border-2 border-transparent hover:border-accent">
              <h3 className="text-xl font-bold mb-3">Ice Cream Plant</h3>
              <p className="text-gray-600 text-sm mb-3">Complete Ice Cream Production</p>
              <p className="text-gray-700 text-sm">From mix preparation to freezing and hardening facilities</p>
              <div className="mt-4 text-green font-semibold">View Details →</div>
            </Link>

            <Link to="/projects/sweetened-milk" className="card-hover bg-white rounded-lg p-6 border-2 border-transparent hover:border-accent">
              <h3 className="text-xl font-bold mb-3">Sweetened Condensed/Evaporated Milk Plant</h3>
              <p className="text-gray-600 text-sm mb-3">Concentrated Milk Products</p>
              <p className="text-gray-700 text-sm">Multi-stage evaporation and concentration systems</p>
              <div className="mt-4 text-green font-semibold">View Details →</div>
            </Link>

            <Link to="/projects/butter-oil" className="card-hover bg-white rounded-lg p-6 border-2 border-transparent hover:border-accent">
              <h3 className="text-xl font-bold mb-3">Butter Oil/Anhydrous Milk Fat Plant</h3>
              <p className="text-gray-600 text-sm mb-3">Premium Fat Products</p>
              <p className="text-gray-700 text-sm">99.5-99.8% butter fat concentration facilities</p>
              <div className="mt-4 text-green font-semibold">View Details →</div>
            </Link>

            <Link to="/projects/casein" className="card-hover bg-white rounded-lg p-6 border-2 border-transparent hover:border-accent">
              <h3 className="text-xl font-bold mb-3">Casein/WPC/Whey Powder Plant</h3>
              <p className="text-gray-600 text-sm mb-3">Protein Products</p>
              <p className="text-gray-700 text-sm">Advanced membrane filtration and drying systems for protein concentrate</p>
              <div className="mt-4 text-green font-semibold">View Details →</div>
            </Link>

            <Link to="/projects/malted-milk" className="card-hover bg-white rounded-lg p-6 border-2 border-transparent hover:border-accent">
              <h3 className="text-xl font-bold mb-3">Malted Milk Powder Plant</h3>
              <p className="text-gray-600 text-sm mb-3">Nutritional Beverages</p>
              <p className="text-gray-700 text-sm">Malt extraction and powder production facilities</p>
              <div className="mt-4 text-green font-semibold">View Details →</div>
            </Link>

            <Link to="/projects/flavored-milk" className="card-hover bg-white rounded-lg p-6 border-2 border-transparent hover:border-accent">
              <h3 className="text-xl font-bold mb-3">Flavored Milk Plant</h3>
              <p className="text-gray-600 text-sm mb-3">UHT Beverages</p>
              <p className="text-gray-700 text-sm">Sterilized flavored milk production with extended shelf life</p>
              <div className="mt-4 text-green font-semibold">View Details →</div>
            </Link>
          </div>
        </div>
      </section>

      {/* Other Industrial Projects */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold mb-12 text-center section-title inline-block">Other Industrial Ventures</h2>
          <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto mt-12">
            <Link to="/projects/effluent" className="card-hover bg-gray-50 rounded-lg p-8 border-2 border-transparent hover:border-accent">
              <h3 className="text-2xl font-bold mb-3">Industrial/Distillery Effluent Treatment</h3>
              <p className="text-gray-600 mb-3">Zero Effluent Discharge Plants</p>
              <p className="text-gray-700 text-sm">Advanced evaporation and drying systems for effluent concentration and solid recovery</p>
              <div className="mt-4 text-green font-semibold">View Details →</div>
            </Link>

            <Link to="/projects/tea-coffee" className="card-hover bg-gray-50 rounded-lg p-8 border-2 border-transparent hover:border-accent">
              <h3 className="text-2xl font-bold mb-3">Instant Tea & Coffee Powder Plant</h3>
              <p className="text-gray-600 mb-3">Beverage Powder Production</p>
              <p className="text-gray-700 text-sm">Complete roasting, extraction, and spray drying facilities for instant beverages</p>
              <div className="mt-4 text-green font-semibold">View Details →</div>
            </Link>

            <Link to="/projects/starch-malt" className="card-hover bg-gray-50 rounded-lg p-8 border-2 border-transparent hover:border-accent">
              <h3 className="text-2xl font-bold mb-3">Starch & Malt Extraction</h3>
              <p className="text-gray-600 mb-3">Malt from Barley, Glucose from Rice</p>
              <p className="text-gray-700 text-sm">Enzymatic extraction and processing plants for malt, glucose, and maltodextrin</p>
              <div className="mt-4 text-green font-semibold">View Details →</div>
            </Link>

            <Link to="/projects/fruits-vegetables" className="card-hover bg-gray-50 rounded-lg p-8 border-2 border-transparent hover:border-accent">
              <h3 className="text-2xl font-bold mb-3">Fruits & Vegetables Processing</h3>
              <p className="text-gray-600 mb-3">Juice, Concentrate & Powder Plants</p>
              <p className="text-gray-700 text-sm">Tomato ketchup, fruit juice concentration, and powder production facilities</p>
              <div className="mt-4 text-green font-semibold">View Details →</div>
            </Link>
          </div>
        </div>
      </section>

      {/* Project Capabilities */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-4xl font-bold mb-12 text-center section-title inline-block">Our Project Capabilities</h2>
            <div className="grid md:grid-cols-4 gap-6 mt-12">
              <div className="text-center">
                <div className="text-5xl mb-4 text-accent">📋</div>
                <h3 className="font-bold text-lg mb-2">Design & Engineering</h3>
                <p className="text-gray-600 text-sm">Custom design solutions tailored to your requirements</p>
              </div>
              <div className="text-center">
                <div className="text-5xl mb-4 text-green">🏭</div>
                <h3 className="font-bold text-lg mb-2">Manufacturing</h3>
                <p className="text-gray-600 text-sm">In-house fabrication with quality control</p>
              </div>
              <div className="text-center">
                <div className="text-5xl mb-4 text-accent">🔧</div>
                <h3 className="font-bold text-lg mb-2">Installation</h3>
                <p className="text-gray-600 text-sm">Professional on-site installation services</p>
              </div>
              <div className="text-center">
                <div className="text-5xl mb-4 text-green">✅</div>
                <h3 className="font-bold text-lg mb-2">Commissioning</h3>
                <p className="text-gray-600 text-sm">Complete testing and commissioning support</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-black text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-4">Ready to Start Your Turnkey Project?</h2>
          <p className="text-xl mb-8 text-gray-300">
            Contact us for detailed project discussion and customized solutions
          </p>
          <Link to="/contact" className="btn-primary px-10 py-4 rounded-lg text-lg font-semibold inline-block">
            Discuss Your Project
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ProjectsOverview;